import { render, staticRenderFns } from "./AttributeGroup.vue?vue&type=template&id=48f5adb6&"
import script from "./AttributeGroup.vue?vue&type=script&lang=js&"
export * from "./AttributeGroup.vue?vue&type=script&lang=js&"
import style0 from "./AttributeGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports